import {
  ExclamationCircleOutlined,
  LeftOutlined,
  QuestionCircleOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useState } from 'react';

import type { BedCategory } from 'app/typings';
import type { ExtranetRoom } from 'app/typings/packages';

import { Room } from './Room/Room';

const ROOMS_PER_PAGE = 4;

export const PER_PERSON = '/pers.';

type OverviewProps = {
  bedCategories: BedCategory[];
  rooms: ExtranetRoom[];
};

export const Overview = ({ bedCategories, rooms }: OverviewProps) => {
  const [currentRoomPage, setCurrentRoomPage] = useState(0);
  const startIndex = currentRoomPage * ROOMS_PER_PAGE;
  const endIndex = startIndex + ROOMS_PER_PAGE;
  const currentRooms = rooms.slice(startIndex, endIndex);

  const handlePrevPage = () => {
    if (currentRoomPage > 0) {
      setCurrentRoomPage(currentRoomPage - 1);
    }
  };

  const handleNextPage = () => {
    if ((currentRoomPage + 1) * ROOMS_PER_PAGE < rooms.length) {
      setCurrentRoomPage(currentRoomPage + 1);
    }
  };

  return (
    <div className="body-section">
      <div className="body-section__title-container">
        <h1>Overview</h1>
      </div>
      <div className="overview-container">
        <div className="overview-container__your-rooms__header">
          <p className="overview-container__your-rooms__title">
            Your rooms (for more than 2 adults)
            <Tooltip
              placement="topLeft"
              arrowPointAtCenter
              title="Contact your Account Manager if there is something wrong in your room configuration"
            >
              <QuestionCircleOutlined />
            </Tooltip>
          </p>
          {rooms.length > ROOMS_PER_PAGE && (
            <div className="pagination">
              <Button onClick={handlePrevPage} disabled={currentRoomPage === 0}>
                <LeftOutlined />
              </Button>
              <Button
                onClick={handleNextPage}
                disabled={endIndex >= rooms.length}
              >
                <RightOutlined />
              </Button>
            </div>
          )}
        </div>
        <div className="overview-container__your-rooms__infos">
          {currentRooms.length > 0 ? (
            <div className="overview-container__your-rooms__infos__rooms">
              {currentRooms.map((room, index) => {
                return (
                  <Room
                    key={`${room.id}`}
                    index={index}
                    room={room}
                    bedCategories={bedCategories}
                  />
                );
              })}
            </div>
          ) : (
            <div className="no-rooms">
              <ExclamationCircleOutlined className="no-rooms_icon" />
              <div>
                <p className="no-rooms_title">No matching room</p>
                <p className="no-rooms_description">
                  You have no room configured for more than 2 adults.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
